<ng-container *ngIf="hasLowLevelLandAreaTitle$|async as vm">
  <ng-container *ngIf="!vm.title">
    <div class="row">
      <div class="col-12">
        <h5 class="my-3 text-mad text-uppercase">
          Parcel Identification
        </h5>
        <hr class="active">
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container [formGroup]="form">
  <div class="row">
    <div class="col-12">
      <mat-label>Would you like to add information on the land</mat-label>
      <mat-radio-group class="ml-4" formControlName="add_info_on_land">
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <mat-radio-button [value]="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <ng-container *ngIf="form.controls.add_info_on_land.value">
    <div class="row mt-2">
      <div class="col-12">
        <agm-map [latitude]="centerLatitude$|async" [longitude]="centerLongitude$|async" [zoom]="15" [usePanning]="true"
          [clickableIcons]="false" (mapReady)="onMapReady($event)">
          <agm-map-type-control></agm-map-type-control>
          <button type="button" id="DrawShape" class="btn btn-white ml-3 mt-1 p-0 map-button map-draw-button"
            style="width: 30px; height: 26px" [hidden]="!(drawAllowed$|async)"
            [class.active]="drawActive$|async" [title]="(drawActive$|async) ? 'Stop drawing' : 'Draw parcel boundary'"
            (click)="onToggleDraw()">
            <mat-icon inline>gesture</mat-icon>
          </button>
          <button type="button" id="DeleteShape" class="btn btn-white ml-3 mt-1 p-0 map-button"
            style="width: 30px; height: 26px" (click)="onDeleteShape()">
            <mat-icon inline>remove_circle_outline</mat-icon>
          </button>
          <ng-container *ngIf="marker$|async as marker">
              <agm-marker *ngIf="marker"
                  [latitude]="marker.lat"
                  [longitude]="marker.lng"
                  [markerDraggable]="false">
              </agm-marker>
          </ng-container>
        </agm-map>
      </div>
    </div>

    <div class="row mt-4" *ngIf="form.controls.boundary_type.value == 2 || form.controls.boundary_type.value == 3">
      <div class="col-lg-12 mb-4" style="display: flex; justify-content: end;" *ngIf="form.controls.boundary_type.value == 3">
        <button mat-raised-button type="button" class="btn btn-primary" color="primary" (click)="onAddPoint()">
          Add a point
        </button>
      </div>

      <div class="col-lg-12 mb-4">
        <table class="table">
          <thead>
            <tr>
              <th>
                No
              </th>
              <th>
                X
              </th>
              <th>Y</th>
              <th>Length ({{staticUnitLengthName$|async}})</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of (dataSource$|async); let i = index;">
              <th>
                {{i + 1}}
              </th>
              <td>
                <ng-container>
                  <input type="text" [value]="item.latitude" (focusout)="onFocusOut($event, 'lat', item)">
                </ng-container>
              </td>
              <td>
                <ng-container>
                  <input type="text" [value]="item.longitude" (focusout)="onFocusOut($event, 'lng', item)">
                </ng-container>
              </td>
              <td>
                <ng-container *ngIf="staticUnit$|async as staticUnit">
                  {{item.length
                  ? staticUnit == 1 ? item.length * imperial_length : item.length
                  : 'N/A'}}
                </ng-container>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>
                Total ({{staticUnitName$|async}})
              </th>
              <td colspan="3">
                <ng-container *ngIf="(area$|async) as area">
                  <ng-container *ngIf="area != null">
                    {{area | mask:'separator.6':{thousandSeparator:','} }} {{staticUnitName$|async}}
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!(area$|async)">
                  N/A
                </ng-container>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-lg-6">
        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['land_parcel_name']">
          <input matInput placeholder="Land Parcel ID" formControlName="land_parcel_name" type="text">
          <mat-hint [formFieldHintState]="form.controls['land_parcel_name']">
            Land Parcel ID <span>required</span>
          </mat-hint>
          <mat-error>
            Land Parcel ID <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            Add coordinates of each boundary cover or pivot point of the land parcel ?
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-6">
            <mat-radio-group formControlName="boundary_type">
              <mat-radio-button [value]="1">No</mat-radio-button>
              <mat-radio-button [value]="2">Draw</mat-radio-button>
              <mat-radio-button [value]="3">Write Down</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-lg-6">
        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['coordinate_reference_system_id']">
          <mat-select 
            placeholder="Coordinate Reference System" formControlName="coordinate_reference_system_id">
            <mat-option *ngFor="let coordinateReferenceSystem of coordinateReferenceSystems$|async"
              [value]="coordinateReferenceSystem.id">{{coordinateReferenceSystem.name}}</mat-option>
          </mat-select>
          <mat-icon matSuffix class="cursor-pointer" (click)="$event.stopPropagation();" container="body"
            [ngbPopover]="'TOOLTIP.LAND_PARCEL.CRS.DESCRIPTION' | translate">help
          </mat-icon>
          <mat-hint [formFieldHintState]="form.controls['coordinate_reference_system_id']">
            Coordinate Reference System <span>required</span>
          </mat-hint>
          <mat-error>
            Coordinate Reference System <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row mt-10">
      <div class="col-12">
        <div class="row">
          <app-land-areas class="col-12"
            [form]="form.controls.land_area"
            [landAreas]="landAreas$|async"
            [lowLevelTitle]="landAreaLowLevelTitle$|async"
            (landAreasChange)="onLandAreasChange($event)"
          ></app-land-areas>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>